import { ProjectResponse, ProjectFilesResponse } from "./models";

// const baseUrl = "http://127.0.0.1:8000";
const baseUrl = "https://nprd-pr-aiqlabadv-app-svc-backend-lnx.azurewebsites.net";

export const use_token = true;

export async function chat(payload, initiateChat, id, feedbackCounter): Promise<ProjectResponse> {
    let user = localStorage.getItem("user_id");
    var json_data = {
        user_message: payload,
        thread_id: id,
        initiate_chat: initiateChat,
        feedback_counter: feedbackCounter,
        // user_ip: "152.59.211.208",
        user_id: user
    };
    let token = localStorage.getItem("token");

    let header = {};
    if (use_token && token != null) {
        header = { 
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
        };
    }
    const response = await fetch(`${baseUrl}/chat`, {
        method: "POST",
        headers: header,
        body: JSON.stringify(json_data)
    });

    const parsedResponse: ProjectResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw `${parsedResponse.message}`;
    }

    return parsedResponse;
}

export async function uploadFiles(payload: Object, chatTitle: String): Promise<ProjectFilesResponse> {
    let user = localStorage.getItem("user_id");
    let token = localStorage.getItem("token");

    let header = {};
    if (use_token && token != null) {
        header = { Authorization: `Bearer ${token}` };
    }

    var formdata = new FormData();

    const files = payload as Object;
    Object.values(files)?.map(function (item: any) {
        formdata.append("files", item);
    });
    formdata.append("conv_title", chatTitle);
    // if(use_token && user != null && token != null){
    //     formdata.append("user_id", user)
    // }

    const response = await fetch(`${baseUrl}/upload-files`, {
        method: "POST",
        headers: header,
        body: formdata
    });

    const parsedResponse: ProjectResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        if(use_token && (parsedResponse.message == "Token expired" || parsedResponse.message == "Sign In with proper Tenant")){
            const get_link = await reAuth();
            window.location.href = get_link.auth_url
        }else{
            throw `${parsedResponse.message}`;
        }
    }
    return parsedResponse;
}

export async function chatHistory(payload: String): Promise<ProjectFilesResponse> {
    let token = localStorage.getItem("token");
    let header = {};
    if (use_token && token != null) {
        header = { Authorization: `Bearer ${token}` };
    }
    let url = "/chat-history";
    if (payload != "") {
        url = `/chat-history/${payload}`;
    }

    const response = await fetch(`${baseUrl}${url}`, {
        method: "GET",
        headers: header
    });

    const parsedResponse: ProjectResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        if(use_token && (parsedResponse.message == "Token expired" || parsedResponse.message == "Sign In with proper Tenant")){
            const get_link = await reAuth();
            window.location.href = get_link.auth_url
        }else{
            throw `${parsedResponse.message}`;
        }
    }
    return parsedResponse;
}

export async function getToken(payload: String): Promise<ProjectFilesResponse> {
    let url = `${payload}`;

    const response = await fetch(`${baseUrl}${url}`, {
        method: "GET"
    });

    const parsedResponse: ProjectResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw `${parsedResponse.message}`;
    }
    return parsedResponse;
}

export async function deleteChat(payload: String): Promise<ProjectFilesResponse> {
    let url = `/chat-history/${payload}`;
    let token = localStorage.getItem("token");
    let header = {};
    if (use_token && token != null) {
        header = { Authorization: `Bearer ${token}` };
    }

    const response = await fetch(`${baseUrl}${url}`, {
        method: "DELETE",
        headers: header
    });

    const parsedResponse: ProjectResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        if(use_token && (parsedResponse.message == "Token expired" || parsedResponse.message == "Sign In with proper Tenant")){
            const get_link = await reAuth();
            window.location.href = get_link.auth_url
        }else{
            throw `${parsedResponse.message}`;
        }
    }
    return parsedResponse;
}

export async function reAuth(): Promise<ProjectFilesResponse> {
    const response = await fetch(`${baseUrl}/auth-url`, {
        method: "GET",
        headers: {}
    });
    console.log(response,"response")
    const parsedResponse: ProjectResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw `${parsedResponse.message}`;
    }
    return parsedResponse;
}

export async function getUser(): Promise<ProjectFilesResponse> {
    console.log("user")
    let token = localStorage.getItem("token");
    let header = {};
    if (use_token && token != null) {
        header = { Authorization: `Bearer ${token}` };
    }

    const response = await fetch(`${baseUrl}/user`, {
        method: "GET",
        headers: header
    });
    console.log(response, response.status, "here")
     if (response.status == 401) {
        const get_link = await reAuth();
        window.location.href = get_link.auth_url
    }
    const parsedResponse: ProjectResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        // throw `${parsedResponse.message}`;
        if(parsedResponse.message != "success"){
            const get_link = await reAuth();
            window.location.href = get_link.auth_url
        }
    }
    return parsedResponse;
}

export async function Logout(): Promise<ProjectFilesResponse> {
    let token = localStorage.getItem("token");
    let header = {};
    if (use_token && token != null) {
        header = { Authorization: `Bearer ${token}` };
    }

    const response = await fetch(`${baseUrl}/logout`, {
        method: "GET",
        headers: header
    });

    const parsedResponse: ProjectResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw `${parsedResponse.message}`;
    }
    return parsedResponse;
}
